import React, { useState, useRef } from 'react';
import BaseComponent from './BaseComponent';
import { Col, Row } from 'reactstrap';
import { KEY_CODES } from 'helpers/sf_constants';

const createDateStr = (month, date, year) => {
    if (month || date || year) {
        return month + "/" + date + "/" + year;
    }
    return null
}

const DateTimeComponent = ({ index, question, onChangeEvent }) => {
    const currentYear = new Date().getFullYear();
    const question_date = question?.value?.toString();
    const slash = '/';
    const dash = '-';
    const delim = (question_date || '').search(slash) > 0 ? slash : dash;
    const dateArr = question_date?.split(delim);
    const month = dateArr?.[0] || '';
    const date = dateArr?.[1] || '';
    const year = dateArr?.[2] || '';

    const [errorMessage, setErrorMessage] = useState("");
    const monthInputRef = useRef(null);
    const dateInputRef = useRef(null);
    const yearInputRef = useRef(null);

    const handleKeyDown = (e, currentRef, nextRef) => {
        const isDeleteKey = e.key === 'Delete' || e.key === 'Backspace' || e.keyCode === KEY_CODES.DELETE; // Check for Delete or backspace key 
        if (isDeleteKey && e.target.value === '') {
            e.preventDefault();
            nextRef.current.focus();
        }
    };

    const handleMonthChange = (newMonth) => {
        if (newMonth.length > 2) {
            return;
        }
        if (newMonth.length === 2) {
            const clampedMonth = Math.min(parseInt(newMonth, 10), 12);
            dateInputRef.current.focus();
            newMonth = clampedMonth.toString().padStart(2, '0');
        }
        onChangeEvent(createDateStr(newMonth || null, date, year, delim));
    };

    const handleDateChange = (newDate) => {
        if (newDate.length > 2) {
            yearInputRef.current.focus();
            return;
        }
        if (newDate.length === 2) {
            const clampedDate = Math.min(parseInt(newDate, 10), 31);
            yearInputRef.current.focus();
            newDate = clampedDate.toString().padStart(2, '0');
        }
        if (newDate == '') {
            monthInputRef.current.focus();
        }

        onChangeEvent(createDateStr(month, newDate, year, delim));
    };

    const handleYearChange = (newYear) => {
        if (newYear.length >= 5) {
            return
        }
        if (newYear == '') {
            dateInputRef.current.focus();
        }
        onChangeEvent(createDateStr(month, date, newYear, delim));
    };
    const handleInput = (e) => {
        let inputValue = e.target.value.replace(/[^0-9]/g, '');

        // Add leading zero only if the length is 1 and the value is less than 10
        const inputRef = e.target === monthInputRef.current ? monthInputRef : dateInputRef;
        const minValue = inputRef === monthInputRef ? 1 : 3;

        if (inputValue.length === 1 && (parseInt(inputValue, 10) < 10) && (parseInt(inputValue, 10) > minValue)) {
            inputValue = '0' + inputValue;
        }

        e.target.value = inputValue;

        if (e.target === monthInputRef.current) {
            handleMonthChange(inputValue);
        } else if (e.target === dateInputRef.current) {
            handleDateChange(inputValue);
        } else if (e.target === yearInputRef.current) {
            handleYearChange(inputValue);
        }
    };
    const handleMonthBlur = (val) => {
        if (val?.length && val?.length === 1 && val !== '0') {
            handleMonthChange('0' + val)
        }
    }
    const handleDateBlur = (val) => {
        if (val?.length && val?.length === 1 && val !== '0') {
            handleDateChange('0' + val)
        }
    }
    return (
        <BaseComponent question={question} className='text-center'>
            <Row key={index} className='d-flex justify-content-center'>
                <Col md={12} className='mb-2 d-flex justify-content-center'>
                    <div className='quote-funnel-date-time'>
                        <i className="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                    <div className="quote-funnel-date-picker">
                        <input
                            ref={monthInputRef}
                            type="number"
                            placeholder="MM"
                            pattern="\d*"
                            value={month}
                            min="1"
                            max="12"
                            onInput={handleInput}
                            autoFocus={true}
                            onChange={(e) => handleMonthChange(e.target.value)}
                            onBlur={(e) => handleMonthBlur(e.target.value)}
                            maxLength="2"
                            className="quote-funnel-answer-centered-date-input"
                        />
                        <span className='quote-funnel-slash'>/</span>
                        <input
                            ref={dateInputRef}
                            type="number"
                            placeholder="DD"
                            pattern="\d*"
                            value={date}
                            min="1"
                            max="31"
                            onInput={handleInput}
                            onChange={(e) => handleDateChange(e.target.value)}
                            onBlur={(e) => handleDateBlur(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, dateInputRef, monthInputRef)}
                            maxLength="2"
                            className="quote-funnel-answer-centered-date-input"
                        />
                        <span className='quote-funnel-slash'>/</span>
                        <input
                            ref={yearInputRef}
                            type="number"
                            placeholder="YYYY"
                            pattern="\d*"
                            value={year}
                            min="0"
                            max={currentYear - 18}
                            onInput={handleInput}
                            onChange={(e) => handleYearChange(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, yearInputRef, dateInputRef)}
                            maxLength="4"
                            className="quote-funnel-answer-centered-date-input"
                        />
                    </div>
                </Col>
                <div className="quote-funnel-error-message text-center">{errorMessage}</div>
            </Row>
        </BaseComponent>
    );
};

export default DateTimeComponent;
